import React__default, { createContext } from 'react';
import PT from 'prop-types';

const NodeSafeHTMLElement = typeof HTMLElement !== 'undefined' ? HTMLElement : Object;
const PortalContext = /*#__PURE__*/createContext(undefined);
/**
 * The PortalContextProvider allows applications to specify a element the descendants popover/popper
 *  will be rended into.
 */
const PortalContextProvider = ({
  portalElementRef,
  children
}) => /*#__PURE__*/React__default.createElement(PortalContext.Provider, {
  value: portalElementRef
}, children);
PortalContextProvider.displayName = 'PortalContextProvider';
PortalContextProvider.propTypes = {
  /**
   * A react ref object to a DOM element that will contain the popover/popper.
   * @type {object}
   */
  portalElementRef: PT.shape({
    current: PT.instanceOf(NodeSafeHTMLElement)
  })
};
PortalContextProvider.defaultProps = {
  portalElementRef: undefined
};
var PortalContext$1 = PortalContext;

export { PortalContextProvider as P, PortalContext$1 as a };
//# sourceMappingURL=PortalContext-fad7e3e0.js.map
